import Image from 'next/image';
import { useState } from 'react';
import styled, { css } from 'styled-components';

import { device } from '@styles/mediaQuery';
import { Feedback } from '@shared/constants/feedback';
import { Carousel } from '@components/organisms';

type FeedbackDesktopProps = {
  content: Feedback[];
};

function FeedbackDesktop({ content }: FeedbackDesktopProps) {
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(1); // Начинаем с первого реального элемента
  const [slides, setSlides] = useState(content);

  const handleNext = () => {
    if (!isTransitioning) setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  const handlePrev = () => {
    if (!isTransitioning) setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex - 1);
  };

  return (
    <Wrapper>
      <Buttons>
        <Button onClick={handlePrev}>
          <Image
            width={25}
            height={42}
            alt="Slide rigth"
            src="/icons/carousel-arrow-left.svg"
          />
        </Button>

        <Button onClick={handleNext}>
          <Image
            width={25}
            height={42}
            alt="Slide rigth"
            src="/icons/carousel-arrow-right.svg"
          />
        </Button>
      </Buttons>

      <CustomBackground />

      <Carousel
        gap={55}
        sideWidth={360}
        centerWidth={590}
        setIsTransitioning={setIsTransitioning}
        isTransitioning={isTransitioning}
        setCurrentIndex={setCurrentIndex}
        currentIndex={currentIndex}
        setSlides={setSlides}
        slides={slides}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: none;

  ${device.laptopL(css`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;

    overflow: hidden;
    flex-direction: column;

    max-width: 1440px;
    margin: 0 auto 75px;
  `)}
`;

const CustomBackground = styled.div`
  background: linear-gradient(to top, #ffffff00, #e0e0e0);
  width: 1400px;
  height: 407px;
  position: absolute;
  bottom: -50px;
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: space-between;
  width: 95%;
  z-index: 2;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  width: 63px;
  height: 63px;
  background-color: white;

  border-radius: 50%;
  box-shadow: 0 0 5px 1px #d2d2d2;
  transition: 0.1s ease-in-out;

  &:hover {
    box-shadow: 0 0 5px 3px #d2d2d2;
  }
`;

export default FeedbackDesktop;
